import React from 'react';
import './Services.css';

function Services() {
  const services = [
    {
      icon: '💻',
      title: 'Software Development',
      description: 'Custom software solutions built with cutting-edge technologies. From web applications to mobile apps, we deliver scalable and robust solutions.',
      features: ['Web Development', 'Mobile Apps', 'Cloud Solutions', 'API Integration']
    },
    {
      icon: '🎯',
      title: 'IT Consultancy',
      description: 'Strategic technology consulting to help your business thrive. We provide expert guidance on architecture, technology stack, and digital transformation.',
      features: ['Tech Strategy', 'Architecture Design', 'Code Review', 'Best Practices']
    },
    {
      icon: '👥',
      title: 'Staffing Solutions',
      description: 'Premium staffing resources for your projects. We connect you with top-tier developers, designers, and IT professionals tailored to your needs.',
      features: ['Contract Staffing', 'Permanent Hire', 'Team Augmentation', 'Remote Teams']
    },
    {
      icon: '🤖',
      title: 'AI Solutions',
      description: 'Harness the power of artificial intelligence to transform your business. We build intelligent systems that automate processes and provide insights.',
      features: ['Machine Learning', 'AI Integration', 'Chatbots', 'Data Analytics']
    },
    {
      icon: '🛠️',
      title: 'Technical Support',
      description: 'Reliable technical support to keep your systems running smoothly. Our expert team provides 24/7 assistance and maintenance for your infrastructure.',
      features: ['24/7 Support', 'System Maintenance', 'Troubleshooting', 'Performance Monitoring']
    },
    {
      icon: '🌐',
      title: 'Remote Work/Support',
      description: 'Flexible remote work solutions and support services. We enable seamless collaboration and provide dedicated remote teams for your projects.',
      features: ['Remote Teams', 'Virtual Collaboration', 'Remote Infrastructure', 'Offshore Support']
    },
    {
      icon: '🔒',
      title: 'CyberSecurity',
      description: 'Comprehensive cybersecurity solutions to protect your digital assets. We implement robust security measures and conduct thorough assessments to safeguard your business.',
      features: ['Security Audits', 'Threat Detection', 'Data Protection', 'Compliance Management']
    },
    {
      icon: '🌍',
      title: 'Networking',
      description: 'Expert networking solutions for seamless connectivity and infrastructure. We design, implement, and maintain reliable network systems for optimal performance.',
      features: ['Network Design', 'Infrastructure Setup', 'System Integration', 'Network Security']
    }
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <h2 className="section-title">Our Services</h2>
        <p className="section-subtitle">
          Comprehensive solutions to power your digital transformation
        </p>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, idx) => (
                  <li key={idx}>
                    <span className="checkmark">✓</span>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
